import React from "react";
import ReactDOM from "react-dom";

// data
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import rootReducer from "reducers";

// styles
import "semantic-ui-css/semantic.min.css";
import "styles/globals.css";

// app
import App from "./App";

const store = configureStore({
	reducer: rootReducer,
});

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById("root")
);
